import React from 'react';
import styled from 'styled-components';

import { colors } from '@/constants/theme';

interface Props {
  title: string;
  icon?: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

function CreditPaymentsSchedule({ title, icon, onClick }: Props) {
  return (
    <Component onClick={onClick}>
      <Title>{title}</Title>
      {icon && <Icon>{icon}</Icon>}
    </Component>
  );
}

export default CreditPaymentsSchedule;

const Title = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: ${colors.main};
`;

const Icon = styled.div`
  margin-left: 6px;

  svg {
    width: 16px;
    height: 16px;

    rect {
      fill: ${colors.main};
    }

    path {
      fill: ${colors.main};
    }
  }
`;

const Component = styled.button`
  cursor: pointer;
  display: flex;
  transition: 0.3s;

  &:hover {
    ${Title} {
      color: ${colors.main100};
    }

    ${Icon} {
      svg {
        fill: ${colors.main100};

        rect {
          fill: ${colors.main100};
        }

        path {
          fill: ${colors.main100};
        }
      }
    }
  }
`;
